import { Subject, SubjectReadModel } from './subject';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core';

@Injectable()
export class AdminSubjectsStorage {

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public getSiteSubjects(siteId: number): Observable<Subject[]> {
        return this.http.get(`${this.settings.apiUrl}/admin/sites/${siteId}/subjects`)
            .pipe(map(sites => deserialize(sites, SubjectReadModel).subjects));
    }
}